import { ITranslationItem } from '../../../../utils/language';

export const feedbackFormData: {
  disclaimerCopy: {
    body: ITranslationItem;
  };
  userInput: {
    label: ITranslationItem;
    placeholder: ITranslationItem;
  };
} = {
  disclaimerCopy: {
    body: {
      nl: '__Belangrijk!__ Vul geen persoonlijke gegevens in, zoals je naam of pincode. We gebruiken je feedback voor het verbeteren van onze service. Hulp nodig? Neem contact met ons op door te e-mailen naar [doorpakken@nl.abnamro.com](mailto:doorpakken@nl.abnamro.com).',
      en: '__Important!__ Please do not enter any personal information, such as your name or PIN. We use your feedback to improve our service. Need help? Contact us by e-mailing [doorpakken@nl.abnamro.com](mailto:doorpakken@nl.abnamro.com).',
    },
  },
  userInput: {
    label: {
      nl: 'Toelichting',
      en: 'Explanatory',
    },
    placeholder: {
      nl: 'Schrijf je antwoord hier',
      en: 'Write your answer here',
    },
  },
};

export const feedbackFormEmailTemplate = (
  pageUrl: string,
  hasScore: boolean = true
) => ({
  emailAddresses: ['doorpakken@nl.abnamro.com'],
  title: 'Feedback via Doorpakken',
  body: {
    body: hasScore
      ? `Op ${pageUrl} is de volgende feedback ontvangen: \n\nHoe tevreden ben je met de uitleg op deze pagina?: {score} \n\nUitleg: {feedback} \n`
      : `Op ${pageUrl} is de volgende feedback ontvangen: \n\nWat voor optie heb je niet kunnen vinden, of wat voor feedback heb je?: {feedback} \n`,
  },
});
